import Em from 'ember';
export default Em.Component.extend({
  classNames: ['composer-media-selector-option', 'button-bare', 'call-to-action', 'composer-media-social'],
  click() {
    this.addAttachment();
  },
  mouseEnter() {
    this.setProperties({
      showDivider: false,
      showCaret: false
    });
  },
  mouseLeave() {
    this.setProperties({
      showDivider: true,
      showCaret: true
    });
  }
});